import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideAuth, StsConfigLoader, StsConfigStaticLoader, OpenIdConfiguration } from 'angular-auth-oidc-client';
import { ConfigService } from '../config/config-service';

const authFactory = (configService: ConfigService) => {
    const config = configService.getConfig('identity');
    return new StsConfigStaticLoader(config as OpenIdConfiguration);
};

export function provideAuthConfig(): EnvironmentProviders {
    return makeEnvironmentProviders([
        provideAuth({
            loader: {
                provide: StsConfigLoader,
                useFactory: authFactory,
                deps: [ConfigService],
            },
        }),
    ]);
}